import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import {
  getPwmProfileStrategyItemPaginated,
  IPwmProfileStrategyItemPaginatedResponse,
} from "api";
import { Nullable } from "config";
import { RootState } from "store";

import { IWesterosPwmStrategyItemModalData } from "./types";
import { WesterosPwmStrategyItemModalMode } from "./enums";

const initialState = {
  strategyItemList: null as Nullable<
    IPwmProfileStrategyItemPaginatedResponse["edges"]
  >,
  totalCount: 1,
  loading: false,
  modalData: {
    open: false,
    mode: WesterosPwmStrategyItemModalMode.VIEW,
  } as IWesterosPwmStrategyItemModalData,
};

export const fetchWesterosPwmStrategyItemList = createAsyncThunk(
  "westeros-pwm-strategy-item/fetchWesterosPwmStrategyItemList",
  async (_, { getState }) => {
    const filters = (getState() as RootState).FiltersReducer;
    if (!Object.values(filters).length) {
      return;
    }
    const response = await getPwmProfileStrategyItemPaginated(filters);
    return response;
  }
);

const westerosPwmStrategyItemSlice = createSlice({
  name: "westeros-pwm-strategy-item",
  initialState,
  reducers: {
    setWesterosPwmStrategyItemModalData: (state, action) => {
      state.modalData = action.payload;
    },
    closeWesterosPwmStrategyItemModal: (state) => {
      state.modalData = initialState.modalData;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      fetchWesterosPwmStrategyItemList.fulfilled,
      (state, action) => {
        return {
          ...state,
          loading: false,
          strategyItemList: action.payload?.edges ?? null,
          totalCount: action.payload?.totalCount ?? 1,
        };
      }
    );
    builder.addCase(fetchWesterosPwmStrategyItemList.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });
  },
});

export const {
  setWesterosPwmStrategyItemModalData,
  closeWesterosPwmStrategyItemModal,
} = westerosPwmStrategyItemSlice.actions;

export default westerosPwmStrategyItemSlice.reducer;
